import {
  getRedirectRoute,
  useRequestPersistedStore,
  useRequestStore,
} from "entities/Request";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { userStore } from "entities/User/store/userStore";

export function SuccessfulSubmitCard({ requestNumber = null }) {
  const { t } = useTranslation("Request");
  const navigate = useNavigate();
  const user = userStore((state) => state.user);
  const request = useRequestStore((state) => state.request);
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );
  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate(getRedirectRoute(viewRequestAs, request?.type));
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return (
    <Card className="p-5 m-5 text-center lh-lg">
      <Trans
        t={t}
        i18nKey="sucessfull_submit"
        values={{ number: (requestNumber ?? request?.number) || "" }}
      >
        Thanks, {{ name: user.first_name }}.
        <strong>You have successfully submitted your request</strong>
        Have a nice day!
      </Trans>
    </Card>
  );
}
